module.exports = __webpack_public_path__ + "media/images/smr-banner-9a16f8661847076b4dfa12e8088bf0a9.png";